<template>
  <div id="userProtocol" @click.self="closeProtocolView">
    <div class="protocolbg">
      <div class="protocolcon">
        <h1>用户服务协议</h1>
        <p>
          提示：为使用岱恩语培的应用软件和其他客户端或网站（以下简称“平台”）所提供的服务，您应当阅读并遵守《用户服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款，以及开通或使用某项服务的单独协议。限制、免责条款及其他需要特别注意的条款可能以黑体加粗或加下划线的形式提示您重点注意，请您重点阅读。除非您已阅读并接受本协议所有条款，否则您（包括您以及您履行监护职责的未成年子女、无民事行为能力者或限制民事行为能力者在内）无权使用岱恩语培提供的服务，您应立即停止注册、使用。您（包括您以及您履行监护职责的未成年子女、无民事行为能力者或限制民事行为能力者在内）注册、使用平台服务即视为您已阅读并同意本协议的约束
        </p>
        <p>
          如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条例，并请在提交注册、提供个人信息资料、购买服务之前寻求法定监护人的同意和指导。
        </p>

        <p>一、协议的适用范围</p>
        <p>
          1.1、本协议是您与岱恩语培之间就您使用平台服务所订立的协议。“岱恩语培”是平台经营者或平台拥有者的单称或合称，指岱恩教育科技有限公司。“用户”是指平台服务使用人，在本协议中更多地称为“您”。
        </p>
        <p>
          1.2、本协议项下的服务是指岱恩语培通过平台向用户提供的服务，用户通过平台可以进行语言学习、培训指导以及其他平台提供的服务等（以下简称“本服务”或“服务”）。
        </p>
        <p>
          1.3、本协议内容同时包括本协议所有条款及岱恩语培已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。
        </p>
        <p>
          1.4、您在使用岱恩语培某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”）。
        </p>
        <p>
          1.5、本协议是用户与岱恩语培共同签订的，适用于您在平台的全部活动。您一旦注册或使用服务，本协议即生效。
        </p>
        <p>
          1.6、在本协议履行过程中，岱恩语培可根据实际情况和需要不时地制定、修改本协议的相关条款和各类规则。一旦本协议内容及相关规则发生变动，岱恩语培将通过相关系统板块或电子邮件、短信提醒等方式公布最新的协议、规则（声明、通知、警示、业务规则等），不再向用户作个别通知。经修订的协议、规则一经公布，立即自动生效，即为本协议不可分割的组成部分，您同样应当遵守。如您对修订后的协议、规则不同意的，您应立即停止使用，停止接受服务；您一旦继续使用或接受服务的，视为您已同意修订后的协议、规则并同意遵守。
        </p>

        <p>二、帐号与密码安全</p>
        <p>
          2.1、您在使用本服务时可能需要注册一个帐号，用户成功注册后将生成用户账户。同时如果平台明确允许用户通过其合法拥有的包括但不限于手机号、微信等账号注册或登录的，用户使用上述方式注册登录平台的，本协议同样对用户适用。用户账户将记载用户本服务中的各项操作和活动，用户对该账户有使用权，账户所有权归岱恩语培。用户账户是用户在平台的唯一标识，是用户登录平台的唯一账户。岱恩语培通过用户的账户和密码来识别指令，任何人确认或使用用户的账户和密码登录平台后通过个人账户在平台的一切行为均视为用户本人真实意思表示和行为，使用的账户和密码登录操作所产生的电子信息记录均为用户本人行为的有效凭据，并由用户本人承担所有法律后果。用户承诺妥善保管其账号和密码，不将个人账号信息泄露给其他任何人。用户同意，确保账户安全是用户的责任。因黑客、病毒或用户的保管疏忽等非岱恩语培故意行为导致用户账户或密码泄露，遭他人非法使用的，岱恩语培不承担任何责任。用户同意，其在平台上按服务流程所确认的状态，将成为岱恩语培进行相关操作唯一依据和明确指令。用户同意相关指令的执行时间以岱恩语培进行实际操作的时间为准。
        </p>
        <p>
          2.2、为加强安全性，您在使用本服务时，登录验证可能采用手机验证码或邮箱验证码等方式，您应当对上述验证码等验证信息加强安全保护。
        </p>
        <p>
          2.3、用户使用用户账户登录平台后，根据岱恩语培的相关规则，以用户账户ID在平台通过点击确认或类似方式进行的各项操作视为用户本人真实意愿并以用户本人名义操作的，具有法律效力。用户应妥善保管自己的账户和密码等账户信息，用户通过前述方式进行各项操作对各方具有法律约束力，用户不得以其账户密码等账户信息被盗用或其他理由否认相关操作的真实性和法律约束力。
        </p>
        <p>
          2.4、岱恩语培特别提醒您应妥善保管您的帐号和密码。当您使用完毕后，应安全退出。因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。
        </p>
        <p>
          2.5、您在平台注册或接受服务过程中，应当按平台要求提供个人正确、完整、有效的信息（包括真实姓名及各项相关资料）。如因您提供的资料不实或者不明确，致使任何一方受到任何延误或者损失的，应当由您承担相应责任。如您提供的个人信息发生变更，您应及时通知岱恩语培予以及时变更。由于您未及时通知、变更的而导致岱恩语培无法联系到您，导致您的服务受到影响的，您应自行承担责任。
        </p>
        <p>
          2.6、用户注册帐号后如果长期（比如连续90日）不登录该帐号，岱恩语培有权回收该帐号，以免造成资源浪费，由此带来的任何损失均由用户自行承担。
        </p>

        <p>三、使用本服务的方式</p>
        <p>
          3.1、您应当通过岱恩语培提供或认可的方式使用本服务。除了本协议外，如您还与岱恩语培签订有其他书面文件涉及本服务如何使用的，您应同时遵守。
        </p>
        <p>
          3.2、您依本协议条款所取得的权利不可转让、分割、共享、出租、合作等；未经岱恩语培书面许可，您不得私自销售、转让、共用、出租平台所提供的服务，否则，岱恩语培有权中止提供本服务并要求更正，或者直接终止本服务，且无需承担任何责任。
        </p>
        <p>
          3.3、您在岱恩语培平台上如涉及使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议等。
        </p>
        <p>
          3.4、您在使用本服务过程中应当遵守国家法律法规及当地相关的法律法规，并尊重当地的道德和风俗习惯。如果您的行为违反了国家法律法规及当地法律法规或道德风俗，您应当为此独立承担责任。
        </p>

        <p>四、基于平台提供服务</p>
        <p>
          4.1、岱恩语培通过平台所提供的服务仅为软件许可及平台网络服务，您可以通过平台网站或平台客户端软件获取相关服务。
        </p>
        <p>
          您应当理解，您使用岱恩语培的服务可能还需自行准备与相关服务有关的终端设备（如电脑、调制解调器、手机等），并承担所需的费用（如电话费、上网费等费用）。
        </p>
        <p>您理解并同意，您使用本服务时会耗用您的终端设备和带宽等资源。</p>
        <p>
          4.2、您不得使用未经岱恩语培授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响。
        </p>
        <p>4.3、因岱恩语培主要依托软件向您提供服务，您还应遵守以下约定：</p>
        <p>
          4.3.1、您在使用本服务的过程中可能需要下载、安装、运行平台客户端软件，对于这些软件，岱恩语培给予您一项个人的、不可转让、不可转授权及非排他性的许可。您仅可为访问或使用本服务的目的而使用这些软件。该许可限于您非商业目的使用；您应在单一终端设备上安装、使用平台客户端软件。你可以为使用软件及服务的目的复制软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息
        </p>
        <p>
          4.3.2、为了改善用户体验、保证服务的安全性及产品功能的一致性，岱恩语培可能会对软件等平台版本进行更新，优化使用体验，如用户收到软件等平台版本更新提示，须尽快完成更新。如更新涉及收费的，您可能需要付费更新。如您未及时更新，您所使用的软件等平台版本将可能无法正常使用，并停止维护。如因您未及时更新导致无法正常使用服务，岱恩语培不承担任何责任。针对部分更新，岱恩语培有权不经向你特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。软件新版本发布后，旧版本的软件可能无法使用。岱恩语培不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本
        </p>
        <p>
          4.3.3、岱恩语培可能为不同的终端设备开发不同的软件版本，您应当根据实际情况从岱恩语培及其授权的第三方选择与所安装终端设备相匹配的软件版本。如果您从未经岱恩语培及其授权的第三方获取软件或与软件名称相同的安装程序，岱恩语培无法保证该软件能够正常使用，并对因此给您造成的损失不予负责
        </p>

        <p>五、推送信息</p>
        <p>
          5.1、您同意岱恩语培可以在提供服务的过程中自行或由第三方合作方向您发送广告、推广或宣传信息（包括商业与非商业信息）（统称“推送信息”），其方式和范围可不经向您特别通知而变更。
        </p>
        <p>
          5.2、岱恩语培可能为您提供选择关闭推送信息的功能，但任何时候您同意不会以岱恩语培未提供前述关闭功能而认为侵犯您的个人隐私或其他合法权利。
        </p>
        <p>
          5.3、岱恩语培依照法律的规定对第三方合作方履行相关义务，您应当自行判断推送信息的真实性并为自己的判断行为负责，除法律明确规定外，您因依该广告信息进行的交易或前述第三方合作方提供的内容而遭受的损失或损害，您应对依推送信息进行的交易负责，岱恩语培不承担责任。
        </p>
        <p>六、收费服务</p>
        <p>
          6.1、岱恩语培的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关的协议及规则。付费服务内容和价格等具体信息以平台公布的以及用户账号下订单信息为准。针对付费服务，如您未及时付费的，您将无法使用该等付费服务。
        </p>
        <p>
          6.2、岱恩语培可能根据实际需要对收费服务的收费标准、方式进行修改和变更，岱恩语培也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，岱恩语培将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。。
        </p>

        <p>七、知识产权及保密</p>
        <p>
          7.1、除岱恩语培另有特别声明外，平台网站、软件及平台上其他信息资料（包括但不限于文字、图片、音频、视频、图表、练习、界面设计、版面框架等）的商标权、著作权、专利权及其他知识产权或其他合法权益均归岱恩语培所有。上述及其他任何本服务包含的内容的知识产权及其他合法权益均受到法律保护，未经岱恩语培书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
        </p>
        <p>
          7.2、与本合同所涉及的岱恩语培及岱恩语培关联企业名称、产品名称、字号、域名、商标、服务标记、LOGO、宣传册、音视频等信息资料及其相关权利的所有权利均归属于岱恩语培及其关联公司；您未经岱恩语培书面许可，不得以任何方式擅自使用。您不得在任何类别项下，申请注册或登记与岱恩语培及其关联公司相关的前述包括但不限于任何商标、服务标记及其他任何类型的知识产权。岱恩语培是相关产品课程内容或运营模式的原创作者和著作权人或相关权利拥有者。任何人未经书面授权，不得复制、改编、摘编、传播或利用其它未经授权方式使用相关课程内容或运营模式，否则，岱恩语培将追究相关侵权责任。本协议的签署，并不代表岱恩语培同意您使用岱恩语培商标品牌、岱恩语培品牌形象代言人的形象（肖像、图片、视频、资料等）。如您需要使用，请事先获得岱恩语培的书面许可。
        </p>
        <p>
          7.3、未经岱恩语培书面许可同意，您不得以任何理由自行或委托第三方以任何方式使用岱恩语培知识产权（岱恩语培自有的或获得第三方授权许可的）及其他权利，否则岱恩语培有权立即单方面终止本协议，并有权要求您赔偿全部损失（包括但不限于经济损失、调查取证费用、公证费用、律师费等）。
        </p>
        <p>7.4、除非岱恩语培书面许可，您不得从事下列任一行为：</p>
        <p>（1）删除软件及其副本上关于著作权的信息；</p>
        <p>
          （2）对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；
        </p>
        <p>
          （3）对岱恩语培拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等
        </p>
        <p>
          （4）对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经岱恩语培授权的第三方工具/服务接入软件和相关系统
        </p>
        <p>
          （5）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的
        </p>
        <p>
          （6）通过非岱恩语培开发、授权的第三方软件、插件、外挂、系统，登录或使用岱恩语培软件及服务，或制作、发布、传播非岱恩语培开发、授权的第三方软件、插件、外挂、系统；
        </p>
        <p>（7）其他侵犯岱恩语培 软件著作权的行为。</p>
        <p>
          （8）侵犯岱恩语培 著作权、专利权、商业秘密、技术方案等合法权益的行为。
        </p>
        <p>
          7.5、未经岱恩语培书面同意及授权，用户不得以任何方式将因本协议之订立或执行所得悉的平台技术数据、商业秘密及其他机密资料和信息提供给任何第三人或向第三人披露或擅自使用。如用户违反前述约定的，岱恩语培有权立即终止本协议并要求用户赔偿其损失。
        </p>
        <p>
          7.6、如平台允许用户发表评论、心得、上传图片等，则该服务属于平台为用户提供信息存储空间，用户该等行为仅表明用用户其个人立场和观点，并不代表平台的立场或观点。由用户所发表内容引起的一切纠纷，由该内容发表者承担全部法律责任。同时，针对用户所发表的内容，用户同意无偿授予平台永久的、不可撤销的、非独占的，全球范围内的使用授权及转授权，平台可基于平台运营、宣传使用目的而使用；如有其他第三方复制或非法利用用户所发表的内容的，用户同意平台有权进行进行维权处理（警告、投诉、举报、索赔等相关）
        </p>

        <p>八、责任承担</p>
        <p>
          8.1、您在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，包括但不限于：
        </p>
        <p>
          （1）发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容
        </p>
        <p>
          （2）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；
        </p>
        <p>（3）恶意虚构事实、隐瞒真相以误导、欺骗他人；</p>
        <p>（4）发布、传送、传播广告信息及垃圾信息；</p>
        <p>（5）其他法律法规禁止的行为。</p>
        <p>
          8.2、如果您违反了第8.1条约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求岱恩语培给予协助。如您的行为造成损害的，您应依法予以赔偿，岱恩语培不承担任何责任；岱恩语培因此遭受损失的，您也应当一并赔偿。
        </p>
        <p>
          8.3、如果岱恩语培发现或收到他人举报您发布的信息违反第8.1条约定，岱恩语培有权进行独立判断并采取技术手段予以删除、屏蔽或断开链接。同时，岱恩语培有权视用户的行为性质，采取包括但不限于暂停或终止服务，限制、冻结或终止本服务，追究法律责任等措施。
        </p>
        <p>
          8.4、用户保证并承诺通过岱恩语培上传或发布的任何资料信息均真实有效；用户承诺不以任何非法目的或途径使用岱恩语培服务及内容，并遵守所有与岱恩语培服务相关的法律、法规及其他规范性文件；用户承诺不会利用平台搜集、探询、索取平台其他用户的个人信息、联络方式及财务状况等；用户承诺不会以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用软件和相关服务；用户承诺严格按照本协议履行义务。因违背上述承诺造成的损失及后果，用户自行负全部责任，与岱恩语培无关；如给岱恩语培造成损失的，用户负有全部赔偿责任
        </p>
        <p>
          8.5、如用户在岱恩语培的某些行为或言论不合法、不真实、不适当、违反有关协议约定、侵犯岱恩语培的利益等，岱恩语培有权基于独立判断直接删除用户在岱恩语培上作出的上述行为或言论，有权采取暂停或注销账户或中止、终止、限制用户使用岱恩语培服务等措施，而无需通知用户，亦无需承担任何责任。如因此而给岱恩语培造成损失的，用户应承担赔偿责任。
        </p>
        <p>
          8.6、用户承诺其不因任何原因在任何渠道发布关于岱恩语培及与岱恩语培有关的不利言论，禁止恶意攻击，否则岱恩语培有权通过各种方式维护自身权益并随时要求用户停止侵害、恢复名誉、消除影响、在业内有影响力的媒体上赔礼道歉、赔偿所有损失等。
        </p>
        <p>
          8.7、如根据本协议约定，您需要向岱恩语培赔偿损失的，赔偿范围包括但不限于经济损失、律师费、公告费、调查取证费、诉讼费及其他费用等。针对该等赔偿义务，岱恩语培有权先行在用户已经支付但尚未使用的付费款项中扣除相应金额，剩余部分可向用户另行主张。
        </p>
        <p>
          8.8、岱恩语培的员工、合作老师为岱恩语培存续及发展的重要支撑力量，用户不得以任何方式劝诱、要求、或者邀请岱恩语培的员工或者合作老师与岱恩语培终止或者解除服务关系，或劝诱、要求、或者邀请岱恩语培的员工或者合作老师接受由用户自己或者用户介绍的其他个人或组织提供（无论正式、兼职、或者临时组织的活动）的任何职务。如用户有违反，用户应当向岱恩语培承担违约赔偿责任，赔偿金额为上述人员离职前所在的岱恩语培岗位上一年度年薪或报酬的两倍。
        </p>
        <p>
          8.9、如岱恩语培本协议约定，给用户造成损失的，岱恩语培需承担相应违约责任。
        </p>

        <p>九、隐私政策</p>
        <p>9.1、保护用户个人信息是岱恩语培的一项基本原则。</p>
        <p>
          9.2、您在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若您填写的信息不完整，则无法使用本服务或在使用过程中受到限制。岱恩语培部分服务需要用户根据岱恩语培要求完成身份认证等必须程序才能享用。用户因未完成身份认证等必须程序而无法享受服务的，岱恩语培不承担任何责任。
        </p>
        <p>
          9.3、一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别等因素的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。
        </p>
        <p>
          9.4、岱恩语培不会将您的个人信息转移或披露给任何非关联的第三方，除非：
        </p>
        <p>（1）相关法律法规或法院、政府机关要求；</p>
        <p>（2）为完成合并、分立、收购或资产转让而转移；或</p>
        <p>（3）本协议另有约定的或为提供您要求的服务所必需。</p>
        <p>
          9.5、岱恩语培非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用岱恩语培的服务前，应事先取得您家长或法定监护人（以下简称"监护人"）的书面同意。
        </p>
        <p>
          9.6、用户同意，岱恩语培可在提供服务过程中以各种方式投放各种商业性信息或其他任何类型的信息（包括但不限于在岱恩语培的任何页面上投放广告），并且用户同意接受岱恩语培通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。
        </p>
        <p>
          9.7、在任何情况下，对于用户使用岱恩语培服务过程中涉及由第三方提供相关服务的责任由该第三方承担，岱恩语培不承担该等责任。用户自行负责因其自身原因导致岱恩语培服务无法提供或提供时发生任何错误而产生的任何损失或责任，岱恩语培不承担责任。
        </p>
        <p>
          9.8、对用户提供的、岱恩语培自行收集的、经认证的个人资料信息，岱恩语培将采用行业标准和惯例保护，并按照本协议及有关规则使用或者披露。非因本协议有特别约定，岱恩语培不会将用户个人资料信息恶意出售或免费共享给任何第三方。但鉴于技术限制以及黑客攻击等，岱恩语培无法确保用户个人资料信息不被泄露出去。
        </p>
        <p>
          9.9、为更好地了解用户的实际情况，提供更为合适的服务，保障交易安全，用户同意岱恩语培及其关联单位可随时通过任何公开或非公开的渠道查询、采集用户的相关信息（诸如个人资料、信用信息等），可以按照用户在岱恩语培上的行为自动追踪用户的相关资料，可在岱恩语培网页上使用诸如“Cookies”的资料收集装置。
        </p>
        <p>
          9.10、用户同意岱恩语培可以自行或通过合作的第三方机构对用户信息（包括但不限于个人身份证信息等）进行核实，并对获得的核实结果进行查看、使用和留存等操作。
        </p>
        <p>
          9.11、岱恩语培基于履行协议、提供服务、解决争议、保障安全等目的使用用户个人信息资料时，无需告知用户。为避免用户通过岱恩语培从事违规违法活动，保护岱恩语培及其他用户的合法权益，岱恩语培有权审查用户资料，通过人工或自动程序对用户资料信息进行形式审核及评价。岱恩语培根据实际情况对用户信息进行的评价可以供其他用户、合作单位参考。
        </p>
        <p>
          9.12、用户同意岱恩语培可以分析研究、商业性利用用户个人资料信息，以便提供更好、更完善、更便利、更有效的服务，改进和提高岱恩语培的相关经营业务水平。在不透露用户隐私资料的前提下，岱恩语培有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。
        </p>
        <p>
          9.13、用户提供给岱恩语培的信息（包括本协议签署之前提供和产生的）及岱恩语培自行获取的用户信息，可用于岱恩语培及因服务必要而委托的第三方为用户提供服务及推荐产品，法律禁止的除外。
        </p>
        <p>
          9.14、岱恩语培可根据有关法律法规、监管政策要求向司法机关和政府部门等有权机关提供用户个人资料。若用户未能按照本协议、岱恩语培有关规则或其与岱恩语培其他用户签订的有关协议的约定履行应尽义务，岱恩语培有权披露用户个人信息及违约事实。岱恩语培有权将上述信息写入网站黑名单，且与任何第三方进行数据共享，或向征信系统申报，或通过任何形式媒体进行公布，由此给用户造成的任何损失，岱恩语培不承担法律责任。
        </p>
        <p>9.15、在本服务活动中，用户无权要求岱恩语培提供其他用户个人资料。</p>
        <p>
          9.16、用户同意，与岱恩语培的协议关系终止后，岱恩语培仍有权继续使用用户在接受岱恩语培服务期间的所有资料信息。
        </p>
        <p>
          9.17、用户同意许可岱恩语培在其相关服务的宣传、推广以及其他岱恩语培认为适合的活动中免费使用用户享受相关服务所涉及的视频及录音、录像、照片，同时其形象可用于岱恩语培平台服务的市场推广和宣传等活动，用户不会加以限制和不会得到相关报酬。但岱恩语培承诺不将带有用户肖像的图片用于毁谤、猥亵、淫秽或其他违法目的。
        </p>

        <p>十、协议终止及账户注销</p>
        <p>
          10.1、基于服务的安全性、合法性原因（诸如用户个人资料不具有真实性、合法性、有效性或完整性或存在异常交易，或存在违反本协议或各项规则，或其他岱恩语培认为存在风险的情况），岱恩语培有权基于单方独立判断，不经事先通知而改变、中止、中断、终止向用户提供部分或全部服务，暂时冻结或永久冻结（注销）用户的账号，并将其注册资料等信息移除或删除，且无须向用户或任何第三方承担任何责任。
        </p>
        <p>
          10.2、非因本协议约定或事先征得岱恩语培书面同意，用户不得擅自解除、终止本协议。
        </p>
        <p>
          10.3、在用户违反本协议及其相关规则，或用户违反相关法律法规规定、监管政策规定，或用户侵犯他人合法权益而被相关权利人要求，或司法机关等有权机关要求，岱恩语培有权通过站内信、电子邮件、微信、QQ等方式中止、终止本协议、关闭用户账户或者限制、中止、终止用户使用岱恩语培部分或全部服务，且无需承担任何责任。但岱恩语培的中止、终止、限制行为并不免除用户根据本协议还未履行完毕的义务。
        </p>
        <p>
          10.4、用户决定不再使用用户账户时，应履行完毕所有义务和责任，并向岱恩语培书面申请注销该用户账户，经岱恩语培审核同意后可正式注销用户账户。如用户账户未通过上述正规方式注销了，用户仍需对使用岱恩语培服务期间的所有责任进行承担。用户的账号被注销后，用户与岱恩语培基于本协议的合同关系即终止，岱恩语培没有义务向任何人披露已注销账号中的任何信息。
        </p>
        <p>
          10.5、在必要时，岱恩语培无需进行事先通知即有权终止提供用户账户服务，并可立即暂停、关闭或删除用户账户及该用户账户中的所有相关资料及档案，并将用户滞留在这些账户的合法资金（如有）根据本协议及相关规则妥善处理。
        </p>
        <p>
          10.6、用户账户的暂停、中断或终止不代表用户责任的终止，用户仍应对使用岱恩语培服务期间的行为承担可能的违约或损害赔偿责任，同时岱恩语培仍可保有用户的相关信息。
        </p>
        <p>
          10.7、若用户使用第三方网站账号注册岱恩语培用户账户，则应对岱恩语培用户账户所对应的第三方网站账号拥有合法的使用权，如用户因故对该第三方网站账号丧失使用权的，则岱恩语培可停止为该用户账户提供服务。
        </p>

        <p>十一、不可抗力及其他免责事由</p>
        <p>
          11.1、您理解，岱恩语培需要定期或不定期对提供平台网站及相关客户端软件或相关设备进行检修或维护，如因此类情况而造成的网络服务在合理时间内的中断，岱恩语培无需为此承担任何责任，但岱恩语培将事先进行通告。你理解并同意岱恩语培将会尽其商业上的合理努力保障你在平台软件及服务中的数据存储安全，但是，岱恩语培并不能就此提供保证。
        </p>
        <p>
          11.2、您理解并同意，岱恩语培的服务是按照现有技术和条件所能达到的现状提供的。岱恩语培会尽最大努力向您提供服务，确保服务的连贯性和安全性；但岱恩语培不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为、政策等原因可能导致的服务中断、数据丢失以及其他的损失和风险。出现上述情况时，岱恩语培将努力及时进行修复，但是由此给您造成的损失，岱恩语培在法律允许的范围内免责。
        </p>
        <p>
          11.3、在法律允许的范围内，岱恩语培对以下情形导致的服务中断或受阻或者任何资料在产生或在传送过程中产生的延误、不准确、错误或遗漏不承担任何责任：
        </p>
        <p>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
        <p>（2）用户或岱恩语培的电脑软件、系统、硬件和通信线路出现故障；</p>
        <p>（3）用户操作不当；</p>
        <p>（4）用户通过非岱恩语培授权的方式使用本服务；</p>
        <p>（5）其他岱恩语培无法控制或合理预见的情形。</p>
        <p>
          11.4、您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，岱恩语培不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：
        </p>
        <p>
          （1）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；
        </p>
        <p>
          （2）因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；
        </p>
        <p>（3）其他因网络信息或用户行为引起的风险。</p>
        <p>
          11.5、您理解并同意，本服务并非为某些特定目的而设计，包括但不限于核设施、军事用途、医疗设施、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，岱恩语培不承担法律责任。
        </p>
        <p>
          11.6、如您违反相关法律法规或本协议的约定，或岱恩语培按照法律规定或主管部门的要求，岱恩语培有权不经通知而中断或终止向您提供服务。岱恩语培依据本协议约定获得处理违法违规内容的权利，该权利不构成岱恩语培的义务或承诺，岱恩语培不能保证及时发现违法行为或进行相应处理。
        </p>
        <p>
          11.7、在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，谨慎处理。
        </p>

        <p>十二、服务的变更、中断、终止</p>
        <p>
          12.1、岱恩语培可能会对服务内容进行变更，也可能会中断、中止或终止服务。
        </p>
        <p>
          12.2、您理解并同意，岱恩语培有权自主决定经营策略，并有权根据业务经营情况随时变更、中断或终止部分或全部是否服务（不管是免费服务还是付费服务）。如变更、中断或终止的服务属于免费服务，岱恩语培无需通知用户，也无需对任何用户或任何第三方承担任何责任；如变更、中断或终止的服务属于收费服务，岱恩语培将提前通知，并对受影响的用户提供相应补偿或提供其他替代性服务。在岱恩语培发生合并、分立、收购、资产转让、经营模式变动等重大变化时，岱恩语培有权独立判断后单方停止服务，终止本协议，也可未经通知您即向第三方转让本服务下相关资产；岱恩语培将本协议下部分或全部服务转交由第三方运营或履行，并通知您。
        </p>
        <p>
          12.3、如发生下列任何一种情形，岱恩语培有权不经通知而中断或终止向您提供的服务：
        </p>
        <p>
          （1）根据法律规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；
        </p>
        <p>（2）您违反相关法律法规或本协议的约定；</p>
        <p>（3）按照法律规定或主管部门的要求；</p>
        <p>（4）出于安全的原因或其他必要的情形。</p>
        <p>
          12.4、岱恩语培有权按本协议六条的约定进行收费。若您未按时足额付费，岱恩语培有权中断、中止或终止提供服务。
        </p>
        <p>
          12.5、您有责任自行备份存储在本服务中的数据。如果您的服务被终止，岱恩语培可以从服务器上永久地删除您的数据,但法律法规另有规定的除外。服务终止后，岱恩语培没有义务向您返还或提供数据。
        </p>
        <p>
          12.6、岱恩语培无需用户同意即可向岱恩语培关联实体或其他第三方转让与岱恩语培平台有关的全部或部分权利和义务。未经岱恩语培事先书面同意，用户不得转让其在本协议项下的任何权利和义务。
        </p>

        <p>十三、未成年人使用条款</p>
        <p>
          13.1、若用户未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用本服务。
        </p>
        <p>
          13.2、监护人、学校均应对未成年人使用本服务时多做引导。特别是家长应关心子女的成长，注意与子女的沟通，指导子女上网应该注意的安全问题，防患于未然。
        </p>

        <p>十四、管辖与法律适用</p>
        <p>
          14.1、本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
        </p>
        <p>14.2、本协议签订地为中华人民共和国北京市朝阳区。</p>
        <p>
          14.3、若您和岱恩语培之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
        </p>

        <p>十五、其他</p>
        <p>
          15.1、本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
        </p>
        <p>
          15.2、本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
        </p>
        <p>
          15.3、岱恩语培无需用户同意即可向第三方转让与岱恩语培有关的全部或部分权利和义务。未经岱恩语培事先书面同意，用户不得转让其在本协议项下的任何权利和义务。
        </p>
        <p>
          15.4、岱恩语培对于用户的通知及任何其他的协议、告示或其他关于用户使用用户账户及服务等的通知，用户同意岱恩语培可通过岱恩语培系统公告、电子邮件、手机短信、无线通讯装置等电子方式或常规的信件传递等方式进行，该等通知于发送之日视为已送达收件人。因信息传输等原因导致用户未在前述通知发出当日收到该等通知的，岱恩语培不承担责任。
        </p>
        <p>
          15.5、用户应提供自己的真实、最新、有效及完整的个人资料，应妥善维护并及时更新自己的个人资料（特别是常用电子邮箱、常用联系电话、常用联系地址、邮编等联系方式），确保其真实、最新、有效及完整、安全。联系方式等个人资料发生变更时，应在3日内进行更新。
        </p>
        <p>
          15.6、本协议中未尽事宜应依照中华人民共和国的法律法规及岱恩语培公布的相关规则、操作指引办理。如果您对本协议或本服务有意见或建议，可与岱恩语培客户服务部门联系，我们会给予您必要的帮助。在法律允许的范围内，本协议最终解释权归岱恩语培所有。
        </p>
        <p>
          15.7用户点击确认同意本协议或通过注册或使用本服务即视为用户同意本协议，本协议立即生效，本协议即在用户和岱恩语培之间产生法律效力。本协议将以电子文件方式留存于岱恩语培平台系统中，并以此作为为双方履行及遵循的依据。本协议可能存在包括中文、英文在内的多种语言的版本，如果存在中文版本与其他语言的版本相冲突的地方，以中文版本为准。
        </p>
      </div>
      <div class="protocolBtn">
        <div class="agreeBtn">
          <van-button class="book-btn confirm bigbuttonletter pointer" @click.stop="agreeB"
            >我知道了</van-button
          >
        </div>
        <!-- <div class="refuseBtn pointer" @click.stop="closeProtocolView">不同意</div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'userProtocol',
  methods: {
    agreeB() {
      this.$emit('agreeB', 'agreeB')
    },
    closeProtocolView() {
      this.$emit('close', 'close')
    }
  }
}
</script>

<style lang="scss" scoped>
.protocolBtn {}
.refuseBtn {
  color: #666;
  font-size: 12px;
  text-align: center;
}
.agreeBtn {
  margin-top: 5px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .book-btn {
    width: calc(100% - 0.3rem);
    margin: 15px auto;
    font-size: 15px;
    font-weight: 600;
    height: 37px !important;
    line-height: 37px !important;
    border-radius: 23px;
    border: none;
    background-image: linear-gradient(135deg, #77b4ff 0%, #1f85fc 100%);
    color: #fff;
    box-shadow: -2px -2px 4px 0px rgba(250, 251, 252, 1),
      2px 2px 6.175px 0.325px rgba(190, 193, 207, 1);
  }
}
#userProtocol {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  .protocolbg {
    background: #fff;
    box-shadow: 2.5px 2.5px 30px 1px rgba(153, 153, 153, 0.15);
    border-radius: 10px;
    position: relative;
    width: 20rem;
    height: 70%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 15px;
    .protocolcon {
      height: calc(100% - 70px);
      overflow-y: auto;
      h1 {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
      }
      p {
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 10px;
      }
    }
    .protocolcon::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/userProtocol.vue